import React, { useCallback, useContext, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getApiTargetInfo } from 'core'
import {
  getEventReportSchedulerSpec,
  upsertEventReportSchedulerSpec,
} from 'api/pgads'
import { ErrorContext } from 'context'
import { Button, Divider, Input, InputNumber, Radio, message } from 'antd'
import { Content } from 'core/screen-util'

const EventReportScheduler = ({ targetInfo }) => {
  const { setError } = useContext(ErrorContext)
  const [data, setData] = useState({})
  const retrieve = useCallback(
    _ =>
      getEventReportSchedulerSpec(targetInfo).fork(setError, data =>
        setData(data[0])
      ),
    [setError, targetInfo]
  )

  useEffect(
    _ => {
      retrieve()
    },
    [retrieve]
  )

  const save = _ => {
    upsertEventReportSchedulerSpec(targetInfo)([data]).fork(setError, _ => {
      message.info('Data Saved.')
      retrieve()
    })
  }

  return (
    <Content>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '150px 150px 150px',
          gap: 20,
        }}
      >
        <div
          style={{
            gridColumnEnd: 'span 2',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            fontSize: '1.4em',
            color: '#000',
          }}
        >
          Event Report Scheduler
        </div>
        <div style={{ gridColumnEnd: 'span 1' }}>
          <Button
            onClick={retrieve}
            style={{ marginLeft: '10px' }}
            type="primary"
            icon="database"
          >
            Retrieve
          </Button>
        </div>
        <Divider style={{ gridColumnEnd: 'span 3' }} />

        <div
          style={{ display: 'grid', textAlign: 'end', alignContent: 'center' }}
        >
          Daily Execution Time :
        </div>

        <InputNumber
          value={data.hour}
          onChange={hour => setData({ ...data, hour })}
          style={{ width: '100%' }}
          placeholder="Hour"
        />
        <InputNumber
          value={data.minute}
          onChange={minute => setData({ ...data, minute })}
          style={{ width: '100%' }}
          placeholder="Minute"
        />

        <div
          style={{ display: 'grid', textAlign: 'end', alignContent: 'center' }}
        >
          Output Directory :
        </div>

        <Input
          style={{ gridColumnEnd: 'span 2', width: '100%' }}
          value={data.outputDirectory}
          onChange={e => setData({ ...data, outputDirectory: e.target.value })}
        />

        <div
          style={{ display: 'grid', textAlign: 'end', alignContent: 'center' }}
        >
          Type :
        </div>

        <Radio.Group
          onChange={e => setData({ ...data, currentMonth: e.target.value })}
          value={data.currentMonth}
        >
          <Radio value="Y">Current Month*</Radio>
          <Radio value="N">Rolling Days</Radio>
        </Radio.Group>
        {data.currentMonth === 'N' && (
          <InputNumber
            value={data.rollingDays}
            onChange={rollingDays => setData({ ...data, rollingDays })}
            style={{ width: '100%' }}
            placeholder="Days"
            title="Days"
          />
        )}
        <div style={{ gridColumnEnd: 'span 1' }} />
        <Divider style={{ gridColumnEnd: 'span 3', margin: '5px' }} />
        <div style={{ gridColumnEnd: 'span 2' }} />
        <Button onClick={save} icon="edit" type="primary">
          Update
        </Button>
      </div>
    </Content>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(EventReportScheduler)
